import type { RecommendedPostsElementProps } from './RecommendedPosts.type';

import type { CSSProperties } from 'react';

export function RecommendedPostsElement(props: RecommendedPostsElementProps) {
  const { element, children, attributes } = props;
  const { gap, width, padding, backgroundColor, borderRadius, borderWidth, borderColor, borderStyle } =
    element.attrs || {};

  return (
    <div
      className="relative flex flex-col"
      style={
        {
          width: '100%',
          maxWidth: width,
          backgroundColor,
          padding,
          borderStyle,
          borderWidth,
          borderRadius,
          borderColor,
          gap,
        } as CSSProperties
      }
      {...attributes}
    >
      {children}
    </div>
  );
}
